import {
  Avatar,
  CardHeader,
  Grid,
  makeStyles,
  SwipeableDrawer,
  Typography,
  Box,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button
} from "@material-ui/core";
import {
  PermIdentity,
  KeyboardArrowRight,
  Home,
  Apps,
} from "@material-ui/icons";
import { filter, uniqBy } from "lodash";
import React, { useCallback, useState } from "react";
import UsePublicgetservice from "../../Services/UsePublicgetservice";
import NavigationList from "./NavigationList";
import LoginDialog from "./LoginDialog";
import UseAuth from "../../Services/UseAuth";
import UseFetchUser from "../../Services/UseFetchuserdetails";
import { useHistory } from "react-router";
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined';
import { mutate } from "swr";
import Utils from "../../Utils";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
const NavigationMenu = ({
  openMenu,
  setOpenMenu,
  HeaderData,
  MENUTYPE = "1",
}) => {
  const history = useHistory();
  const classes = NavigationStyles();
  const [openDialog, setopenDialog] = useState(false);
  const { data: isLoggedIn } = UseAuth();
  const { data: userdetails, isLoading } = UseFetchUser(isLoggedIn);
  const handleClickOpenDialog = () => {
    setopenDialog(true);
  };
  let iconColor =
    HeaderData.primaryHeader && HeaderData.primaryHeader.iconColor
      ? HeaderData.primaryHeader.iconColor
      : "rgba(0, 0, 0, 0.54)";
  let textColor =
    HeaderData.primaryHeader && HeaderData.primaryHeader.textColor
      ? HeaderData.primaryHeader.textColor
      : "#000";
  const { data: Megamenudata } = UsePublicgetservice(
    "getHomePageMappedDetails/publicAccess/getAllCategorySection"
  );
  const Megamenu_items_arr = [
    {
      name: "Categories",
      icon: Apps,
      children: [],
      Access: true,
    },
  ];
  if (parseInt(MENUTYPE) === 1) {
    uniqBy(Megamenudata?.data.listSubCategory, (o) => o.id).forEach((data) => {
      Megamenu_items_arr[0].children.push({
        name: data.name,
        id: data.id,
        Access: true,
        href: `/p/s/${data.name.replace(/\//g, "~")}/1`,
      });
    });
  } else if (parseInt(MENUTYPE) === 2) {
    uniqBy(Megamenudata?.data.listSubCategory, (o) => o.categoryId.id).forEach(
      (data) => {
        Megamenu_items_arr[0].children.push({
          name: data.categoryId.name,
          id: data.categoryId.id,
          Access: true,
          children: [],
        });
      }
    );
    Megamenu_items_arr[0].children.forEach((data) => {
      filter(
        Megamenudata.data.listSubCategory,
        (o) => o.categoryId.id === data.id
      ).forEach((data1) => {
        data.children.push({
          name: data1.name,
          Access: true,
          href: `/p/s/${data1.name.replace(/\//g, "~")}/1`,
        });
      });
    });
  } else {
    uniqBy(
      Megamenudata?.data.listSubCategory,
      (o) => o.categoryId.majorCategoryId.id
    ).forEach((data) => {
      Megamenu_items_arr[0].children.push({
        name: data.categoryId.majorCategoryId.name,
        id: data.categoryId.majorCategoryId.id,
        Access: true,
        children: [],
      });
    });
    Megamenu_items_arr[0].children.forEach((data1) => {
      let uniqcategory = uniqBy(
        Megamenudata.data.listSubCategory,
        (o) => o.categoryId.id
      );
      filter(
        uniqcategory,
        (o) => o.categoryId.majorCategoryId.id === data1.id
      ).forEach((data) => {
        data1.children.push({
          name: data.categoryId.name,
          id: data.categoryId.id,
          Access: true,
          children: [],
        });
      });
    });

    Megamenu_items_arr[0].children.forEach((data) => {
      data.children.forEach((data) => {
        filter(
          Megamenudata.data.listSubCategory,
          (o) => o.categoryId.id === data.id
        ).forEach((data1) => {
          data.children.push({
            name: data1.name,
            Access: true,
            href: `/p/s/${data1.name.replace(/\//g, "~")}/1`,
          });
        });
      });
    });
  }
  const Close = useCallback(() => {
    setOpenMenu(!openMenu);
  }, [openMenu, setOpenMenu]);
  const onOpen = useCallback(() => {
    setOpenMenu(true);
  }, [setOpenMenu]);
  return (
    <React.Fragment>
    <SwipeableDrawer open={Boolean(openMenu)} onClose={Close} onOpen={onOpen}>
      <Grid container className={classes.menuList}>
        <Box width="256px">
          {!isLoggedIn&&<CardHeader
            className={classes.signCard}
            avatar={
              <Avatar
                style={{
                  color: iconColor,

                  backgroundColor: "transparent",
                }}
              >
                <PermIdentity color="inherit" />
              </Avatar>
            }
            title={
              <Typography style={{ color: textColor }} variant="h3">
                Sign in
              </Typography>
            }
            onClick={()=>{
              handleClickOpenDialog();
              Close();
            }}
            disableTypography
            action={
              <Box mt={1}>
                <IconButton style={{ color: iconColor }} aria-label="settings">
                  <KeyboardArrowRight color="inherit" />
                </IconButton>
              </Box>
            }
            style={{
              padding: "12px 8px",
              backgroundColor: HeaderData?.primaryHeader?.bgColor,
            }}
          />}
          {isLoggedIn && (
            <CardHeader
              className={classes.userCard}
              avatar={
                <Avatar
                  src={!isLoading && userdetails.picture}
                  alt={"profile"}
                  style={{
                    color: "white",
                    // backgroundColor: !picture && "purple",
                  }}
                >
                  {!isLoading &&
                  userdetails.name &&
                  Utils.getInitial(userdetails.name)}
                </Avatar>
              }
              title={
                <Box my={2}>
                  <Typography gutterBottom variant="h3" color="primary">
                    {!isLoading && userdetails.name}
                  </Typography>
                  <Typography gutterBottom variant="body2" display="block">
                    {!isLoading && userdetails.email}
                  </Typography>
                </Box>
              }
              subheader={
                <Box display="flex" flexDirection="column">
                  {/* <Box color="rgba(0,0,0,.6)" fontSize="13px" fontWeight="500">{roleName}</Box> */}
                  {/* <Box>{companyName}</Box> */}
                  <Button 
                    onClick={() => {
                      history.replace("/profile");
                      Close();
                    }} color="primary"
                  >
                    Manage Your Profile
                  </Button>
                </Box>
              }
              onClick={() => {
                history.replace("/profile");
                Close();
              }}
              action=""
            />
          )}
          <Divider />
          <List className={classes.megaMenu}>
            <ListItem
              button
              onClick={() => {
                history.replace("/");
                Close()
              }}
            >
              <ListItemIcon>
                <Home />
              </ListItemIcon>
              <ListItemText primary={"Home"} />
            </ListItem>
            {Megamenu_items_arr.map((data, i) => (
              <NavigationList key={i} data={data} closeNav={Close} />
            ))}
            {/* {menu_items.map((data, i) => (
              <Fragment key={i}>
                <NavigationList data={data} closeNav={closeNav} />
              </Fragment>
            ))} */}
            {isLoggedIn && (
              <React.Fragment>
                <ListItem
                  button
                  onClick={() => {
                    history.replace("/orders/1");
                    Close()
                  }}
                >
                  <ListItemIcon>
                    <ListAltOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Orders"} />
                </ListItem>
                <ListItem
                  onClick={() => {
                    localStorage.removeItem("access token");
                    mutate("auth", false);
                    history.replace("/");
                    Close();
                  }}
                  button
                >
                  <ListItemIcon>
                    <LockOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText primary="Sign Out" />
                </ListItem>
              </React.Fragment>
            )}
          </List>
        </Box>
      </Grid>
    </SwipeableDrawer>
    <LoginDialog openDialog={openDialog} setopenDialog={setopenDialog} />
    </React.Fragment>
  );
};

export default NavigationMenu;
const NavigationStyles = makeStyles((theme) => ({
  mediaLogo: {
    padding: 5,
    objectFit: "contain",
    maxHeight: "65px",
  },
  logoLink: {
    height: "65px",
    overflow: "hidden",
    width: "100%",
    textAlign: "center",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    display: "flex",
  },
  loginbutton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      color: "rgba(0, 0, 0, 0.87)",
      "& .MuiListItemIcon-root > *": {
        color: "rgba(0, 0, 0, 0.54) !important",
      },
    },
  },
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  menuList: {
    "& .MuiList-padding": {
      padding: 0,
    },
    "& .MuiDrawer-paper": {
      width: "90%",
    },
    "& .MuiCollapse-container": {
      "& .MuiListItem-button": {
        paddingLeft: "30px",
      },
    },
    "& .MuiListItemIcon-root": {
      minWidth: "36px",
      fontSize: "20px",
    },
    "& .MuiListItem-root": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    "& .MuiListItemText-root": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      paddingRight: 10,
    },
  },
  megaMenu: {
    "& > .MuiListItem-root .MuiTypography-body1": {
      fontWeight: 500,
    },
  },
  homeMenuButton: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  loginMenuButton: {
    backgroundColor: theme.palette.primary,
    color: "white",
    marginBottom: 10,
    "& :hover": {
      backgroundColor: theme.palette.primary,
    },
  },
  menuIcon: {
    display: "flex",
  },
  signList: {
    bottom: 0,
    position: "fixed",
    width: "256px",
    backgroundColor: "#fff",
    boxShadow: "0px -3px 6px rgba(0,0,0,0.1)",
  },
  signCard: {
    cursor: "pointer",
  },
  userCard: {
    cursor: "pointer",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    "& .MuiCardHeader-avatar": {
      marginRight: 0,
    },
  },
}));
